import { render, staticRenderFns } from "./SizeGuideModal.vue?vue&type=template&id=1f274b02"
import script from "./SizeGuideModal.vue?vue&type=script&lang=js"
export * from "./SizeGuideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports